import { dateRangeBounds, dateRangeFromPickers, rangeDateValueLabel } from '~/components/AiSearchChips/DateRangeChip/DateRangeChip.utils';
import { localizeStartOnType } from '../services-localize';
export const START_ON_ANNIVERSARY_OPTION = 'yearlyEffectiveDate';
export const START_ON_DATE_OPTION = 'date';
export const usesStartOnCheckboxEditor = (priceIncrease)=>{
    var _ref, _ref1;
    var _priceIncrease_startOnType_nin, _priceIncrease_startOnType, _priceIncrease_startOnType_in, _priceIncrease_startOnType1;
    return ((_ref = (_priceIncrease_startOnType = priceIncrease.startOnType) === null || _priceIncrease_startOnType === void 0 ? void 0 : (_priceIncrease_startOnType_nin = _priceIncrease_startOnType.nin) === null || _priceIncrease_startOnType_nin === void 0 ? void 0 : _priceIncrease_startOnType_nin.length) !== null && _ref !== void 0 ? _ref : 0) > 0 || ((_ref1 = (_priceIncrease_startOnType1 = priceIncrease.startOnType) === null || _priceIncrease_startOnType1 === void 0 ? void 0 : (_priceIncrease_startOnType_in = _priceIncrease_startOnType1.in) === null || _priceIncrease_startOnType_in === void 0 ? void 0 : _priceIncrease_startOnType_in.length) !== null && _ref1 !== void 0 ? _ref1 : 0) > 1;
};
export const usesStartOnRadioEditor = (priceIncrease)=>{
    var _ref;
    var _priceIncrease_startOnType_in, _priceIncrease_startOnType;
    return priceIncrease.startOn != null || !usesStartOnCheckboxEditor(priceIncrease) && ((_ref = (_priceIncrease_startOnType = priceIncrease.startOnType) === null || _priceIncrease_startOnType === void 0 ? void 0 : (_priceIncrease_startOnType_in = _priceIncrease_startOnType.in) === null || _priceIncrease_startOnType_in === void 0 ? void 0 : _priceIncrease_startOnType_in.length) !== null && _ref !== void 0 ? _ref : 0) > 0;
};
export const priceIncreaseStartSelected = (priceIncrease)=>{
    var _ref;
    var _priceIncrease_startOnType_in, _priceIncrease_startOnType;
    if (priceIncrease.startOn != null) return START_ON_DATE_OPTION;
    const isAnniversary = (_ref = (_priceIncrease_startOnType = priceIncrease.startOnType) === null || _priceIncrease_startOnType === void 0 ? void 0 : (_priceIncrease_startOnType_in = _priceIncrease_startOnType.in) === null || _priceIncrease_startOnType_in === void 0 ? void 0 : _priceIncrease_startOnType_in.includes(START_ON_ANNIVERSARY_OPTION)) !== null && _ref !== void 0 ? _ref : false;
    return isAnniversary ? START_ON_ANNIVERSARY_OPTION : START_ON_DATE_OPTION;
};
export const priceIncreaseStartDateBounds = (startOn)=>dateRangeBounds(startOn);
export const priceIncreaseStartValueLabel = (priceIncrease, t)=>{
    var _ref;
    var _priceIncrease_startOnType;
    if (priceIncrease.startOn != null) {
        return rangeDateValueLabel(priceIncrease.startOn, t.servicesStartOnType.yearly());
    }
    const values = (_ref = (_priceIncrease_startOnType = priceIncrease.startOnType) === null || _priceIncrease_startOnType === void 0 ? void 0 : _priceIncrease_startOnType.in) !== null && _ref !== void 0 ? _ref : [];
    return values.map((value)=>localizeStartOnType(t, value)).join('/');
};
export const priceIncreaseStartFromRadio = (param)=>{
    let { selected, from, to } = param;
    if (selected === START_ON_ANNIVERSARY_OPTION) return {
        startOnType: {
            in: [
                START_ON_ANNIVERSARY_OPTION
            ]
        }
    };
    if (selected !== START_ON_DATE_OPTION) return undefined;
    const startOn = dateRangeFromPickers({
        from,
        to
    });
    return startOn == null ? {
        startOnType: {
            in: [
                'yearly'
            ]
        }
    } : {
        startOn
    };
};
